import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ColumnsType } from 'antd/es/table';
import { get, map } from 'lodash';
import moment from 'moment';
import { DisplayName } from 'components/base/DisplayName';
import SearchInput from 'components/base/SearchInput';
import MenteeCard from 'components/mentoring/mentee/MenteeCard';
import InternFilterModal from 'components/modal/InternFilterModal';
import { getInterns, setInterestedIntern, getInterestedInterns } from 'libs/api/user';
import { useDataApi, usePagination } from 'libs/hooks';
import { TListResponse, TPagination, TModalState } from 'modules/types';
import { TSimpleMentee, TUser } from 'modules/user';
import { CWindowWidth } from 'constants/base.const';
import { ERoute } from 'enums/route.enum';
import { Tabs, Col, Row, Typography, Table, Tag, Button, Badge, List } from 'antd';
import styled from 'styled-components';
import { MenteeColor, TableWrapper, device, LightGrayColor, PrimaryColor } from 'GlobalStyles';
import CheckedSource from 'assets/icons/FavoriteChecked.webp';
import UncheckedSource from 'assets/icons/FavoriteUnchecked.webp';
import BackgroundSource from 'assets/images/banners/9.webp';

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const CompanyInternFinderWrapper = styled.div`
  .ant-tabs-top > .ant-tabs-nav::before,
  .ant-tabs-bottom > .ant-tabs-nav::before,
  .ant-tabs-top > div > .ant-tabs-nav::before,
  .ant-tabs-bottom > div > .ant-tabs-nav::before {
    border-bottom: 1px solid ${LightGrayColor};
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    font-weight: bold;
  }
  .row-box {
    border: 1px solid ${LightGrayColor};
    box-sizing: border-box;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
  }
  .title_wrapper {
    width: 100%;
    height: 220px;
    background: linear-gradient(0deg, rgba(42, 71, 83, 0.3), rgba(42, 71, 83, 0.3)), url(${BackgroundSource});
    background-size: cover;
    padding: 70px 10px;
    .ant-typography {
      width: 100%;
      max-width: ${CWindowWidth - 300}px;
      color: #fff;
      margin: auto;
      display: block;
    }
    span.ant-typography {
      font-size: 16px;
    }
  }
  .ant-typography {
    color: #14112a;
  }

  .intern_wrapper {
    width: 100%;
    height: 70px;
    font-size: 10px;
    display: block;
    border-radius: 10px;
    background-color: #999999;
    padding: 10px 30px;
    white-space: pre-line;
    word-break: break-word;
  }
  .column-title {
    color: #000;
    font-size: 13px;
    @media screen and ${device.md} {
      font-size: 8px;
    }
  }
  .column-data {
    font-size: 17px;
    @media screen and ${device.md} {
      font-size: 10px;
    }
  }
  .column-large-data {
    font-size: 23px;
    font-weight: bold;
    @media screen and ${device.md} {
      font-size: 10px;
    }
  }
  .filter-tag {
    background: transparent;
    border-radius: 8px;
    border: 1px solid ${PrimaryColor};
    padding: 3px 10px;
    color: ${PrimaryColor};
    font-size: 13px;
    .anticon-close {
      color: ${PrimaryColor};
    }
  }
`;

const InterestedButton = ({ mentee }: { mentee: TSimpleMentee }) => {
  const [isInterested, setIsInterested] = useState(get(mentee, 'is_interested', false));

  async function handleInterested(menteeId: number) {
    try {
      await setInterestedIntern({
        mentee_id: menteeId,
        is_interested: !isInterested,
      });
      setIsInterested(!isInterested);
    } catch (e) {
      throw e;
    }
  }

  return (
    <div className='hide-on-mobile'>
      <div onClick={handleInterested.bind(null, get(mentee, 'id'))} className='favorite-btn'>
        {isInterested === true ? (
          <img alt='checked' style={{ transform: 'translateY(50%)' }} src={CheckedSource} />
        ) : (
          <img alt='unchecked' style={{ transform: 'translateY(50%)' }} src={UncheckedSource} />
        )}
      </div>
    </div>
  );
};

const CompanyInternFinder = () => {
  const [key, setKey] = useState('all');

  const ListHeader = ({
    pagination,
    reloadPage,
    total,
  }: {
    pagination: TPagination;
    reloadPage: any;
    total: number;
  }) => {
    const [internFilterModal, setInternFilterModal] = useState<TModalState>({
      record: '',
      visible: false,
    });
    const [filterTagList, setFilterTagList] = useState<Array<string>>([]);
    const [tagCount, setTagCount] = useState(0);

    return (
      <>
        <Row id='card-list-header' justify='space-between' gutter={[16, 6]}>
          <Col xs={24} sm={8} md={8} lg={8} xl={8}>
            <Text strong>총 {total}명의 인턴</Text>
          </Col>
          <Col xs={16} sm={8} md={8} lg={8} xl={8} style={{ textAlign: 'center' }}>
            <SearchInput pagination={pagination} reloadPage={reloadPage} placeHolder='검색어 입력' />
          </Col>
          <Col xs={8} sm={8} md={8} lg={8} xl={8}>
            <div style={{ float: 'right' }}>
              <Badge count={tagCount} dot>
                <Button
                  size='small'
                  onClick={() => {
                    setInternFilterModal({
                      visible: true,
                      onFinish: (data: any) => {
                        reloadPage({
                          current: 1,
                          pageSize: pagination.pageSize,
                          countryType: get(data, 'countryType'),
                          gpa: get(data, 'gpa'),
                          intern: get(data, 'intern'),
                        });
                        setFilterTagList(get(data, 'tagNames', []));
                        setTagCount(get(data, 'count'));
                      },
                    });
                  }}
                >
                  필터
                </Button>
              </Badge>
            </div>
            <InternFilterModal modalState={internFilterModal} setModalState={setInternFilterModal} />
          </Col>
        </Row>
        <div>
          {map(filterTagList, (v) => (
            <Tag className='filter-tag' visible={true}>
              {v}
            </Tag>
          ))}
        </div>
      </>
    );
  };

  const InternListAll = () => {
    const [pagination, setPagination] = usePagination(10);
    const reloadPage = (page?: Partial<TPagination>) => {
      setPagination({
        ...pagination,
        ...page,
      });
    };
    const getPromise = getInterns.bind(null, {
      params: {
        current: pagination.current,
        pageSize: pagination.pageSize,
        q: pagination.q,
        companyName: pagination.companyName,
        countryType: pagination.countryType,
        gpa: pagination.gpa,
        intern: pagination.intern,
      },
    });
    const [{ data, loading }, setCallback] = useDataApi<TListResponse<TSimpleMentee>>(getPromise, {
      contents: [],
      last: false,
    });

    useEffect(() => {
      setCallback(() => getPromise);
    }, [pagination]);

    const columns: ColumnsType<TSimpleMentee> = [
      {
        title: '이름',
        dataIndex: 'user',
        width: '18%',
        render: (user: TUser, record: TSimpleMentee) => {
          return (
            <Link
              target='_blank'
              style={{ marginLeft: '12px' }}
              to={`${ERoute.CompanyInternView.replace(':record_id', String(get(record, 'id')))}`}
            >
              <span className='hide-on-mobile'>
                <Tag className='small-tag' color={MenteeColor}>
                  멘티
                </Tag>
              </span>
              <Text className='column-large-data'> {get(user, 'fullname')} </Text>
            </Link>
          );
        },
      },
      {
        title: '대학',
        dataIndex: 'user',
        width: '30%',
        render: (user: TUser, record: TSimpleMentee) => {
          return (
            <Link
              target='_blank'
              style={{ marginLeft: '8px' }}
              to={`${ERoute.CompanyInternView.replace(':record_id', String(get(record, 'id')))}`}
            >
              <div className='column-title'>학교</div>
              <Text className='column-data'>
                {DisplayName(get(user, 'educations', [])?.slice(-1)[0]?.university_name)}
              </Text>
            </Link>
          );
        },
      },
      {},
      {
        title: '입학년도',
        dataIndex: 'user',
        align: 'right',
        width: '12%',
        render: (user: TUser, record: TSimpleMentee) => {
          return (
            <Link
              target='_blank'
              to={`${ERoute.CompanyInternView.replace(':record_id', String(get(record, 'id')))}`}
            >
              <div className='column-title'>입학년도</div>
              <Text className='column-data'>
                {moment(get(user, 'educations', [])?.slice(-1)[0]?.date_from).format('YYYY.MM')}
              </Text>
            </Link>
          );
        },
      },
      {
        title: '졸업년도',
        dataIndex: 'user',
        align: 'right',
        width: '12%',
        render: (user: TUser, record: TSimpleMentee) => {
          return (
            <Link
              target='_blank'
              to={`${ERoute.CompanyInternView.replace(':record_id', String(get(record, 'id')))}`}
            >
              <div className='column-title'>졸업년도</div>
              <Text className='column-data'>
                {moment(get(user, 'educations', [])?.slice(-1)[0]?.date_to).format('YYYY.MM')}
              </Text>
            </Link>
          );
        },
      },
      {
        title: '학점',
        dataIndex: 'gpa',
        width: '8%',
        align: 'right',
        render: (gpa: number, record: TSimpleMentee) => {
          return (
            <Link
              target='_blank'
              to={`${ERoute.CompanyInternView.replace(':record_id', String(get(record, 'id')))}`}
            >
              <div className='column-title'>학점</div>
              <Text className='column-data'>{gpa}</Text>
            </Link>
          );
        },
      },
      {
        align: 'right',
        width: '12%',
        render: (record: TSimpleMentee) => {
          return (
            <Link
              target='_blank'
              to={`${ERoute.CompanyInternView.replace(':record_id', String(get(record, 'id')))}`}
            >
              <div className='column-title'>컨설팅 인턴 경력</div>
              <Text className='column-data'>
                {get(record, 'has_consulting_career') === true ? '있음' : '없음'}
              </Text>
            </Link>
          );
        },
      },
      {
        align: 'center',
        width: '7%',
        render: (record: TSimpleMentee) => {
          return <InterestedButton mentee={record} />;
        },
      },
    ];

    return (
      <div
        style={{
          maxWidth: `${CWindowWidth - 200}px`,
          margin: '10px auto',
          padding: '0px 10px',
        }}
      >
        <ListHeader pagination={pagination} reloadPage={reloadPage} total={get(data, 'total')} />
        <TableWrapper
          style={{
            maxWidth: `${CWindowWidth - 300}px`,
            margin: 'auto',
            marginTop: '30px',
          }}
        >
          <Table
            rowClassName='row-box'
            showHeader={false}
            tableLayout={'fixed'}
            rowKey='id'
            loading={loading}
            columns={columns}
            pagination={{ ...pagination, total: get(data, 'total', 0) }}
            size='small'
            dataSource={get(data, 'contents', [])}
            onChange={(page, filters, sorter, extra) => {
              reloadPage(page);
            }}
          />
        </TableWrapper>
      </div>
    );
  };

  const InternListInterested = () => {
    const [pagination, setPagination] = usePagination(16);
    const reloadPage = (page?: Partial<TPagination>) => {
      setPagination({
        ...pagination,
        ...page,
      });
    };
    const getPromise = getInterestedInterns.bind(null, {
      params: {
        current: pagination.current,
        pageSize: pagination.pageSize,
        q: pagination.q,
        companyName: pagination.companyName,
        countryType: pagination.countryType,
        gpa: pagination.gpa,
        intern: pagination.intern,
      },
    });

    const [{ data, loading }, setCallback] = useDataApi<TListResponse<TSimpleMentee>>(getPromise, {
      contents: [],
      last: false,
    });

    useEffect(() => {
      setCallback(() => getPromise);
    }, [pagination]);

    return (
      <div
        style={{
          maxWidth: `${CWindowWidth - 200}px`,
          margin: '10px auto',
          padding: '0px 10px',
        }}
      >
        <ListHeader pagination={pagination} reloadPage={reloadPage} total={get(data, 'total')} />
        <List
          pagination={{
            ...pagination,
            total: get(data, 'total', 0),
            position: 'bottom',
            hideOnSinglePage: true,
            onChange: (page) => {
              reloadPage({
                current: page,
                pageSize: pagination.pageSize,
              });
            },
          }}
          loading={{ spinning: loading, delay: 1000 }}
          style={{ paddingTop: '20px' }}
          grid={{ gutter: 16, xs: 1, sm: 2, md: 2, lg: 4, xl: 4, xxl: 4 }}
          dataSource={get(data, 'contents')}
          renderItem={(item) => (
            <List.Item>
              <MenteeCard mentee={item} pagination={pagination} reloadPage={reloadPage} />
            </List.Item>
          )}
        />
      </div>
    );
  };

  return (
    <CompanyInternFinderWrapper>
      <div className='title_wrapper'>
        <Title>My Intern Finder</Title>
        <Text style={{ marginTop: '10px', fontSize: '16px' }}>
          Career Step에서 팀에 필요한 인재를 찾아보세요.
        </Text>
      </div>
      <Tabs
        activeKey={key}
        onChange={(e) => {
          setKey(e);
        }}
        centered={true}
      >
        <TabPane tab='모두 보기' key='all'>
          <InternListAll />
        </TabPane>
        <TabPane tab='내가 찜한 인턴' key='interested'>
          <InternListInterested />
        </TabPane>
      </Tabs>
    </CompanyInternFinderWrapper>
  );
};

export default CompanyInternFinder;
